import { LegalPage, LegalSection } from "@/components/LegalPage";

export const Privacy = () => (
    <LegalPage title="Privacy Policy" updated="July 2026" testId="privacy-page">
        <LegalSection title="1. Overview">
            <p>
                RedeemDeals ("RedeemDeals", "we", "us") provides an AI-powered platform for building websites and web
                applications. This Privacy Policy explains what information we collect, how we use it, and the choices
                you have.
            </p>
        </LegalSection>
        <LegalSection title="2. Information We Collect">
            <p>Account details you provide, such as your name and email address.</p>
            <p>Content you create on the platform, including prompts, projects, and settings.</p>
            <p>Usage data such as device type, browser, pages visited, and interactions with the service.</p>
            <p>Cookies and similar technologies that keep the service working and help us understand usage.</p>
        </LegalSection>
        <LegalSection title="3. How We Use Information">
            <p>To operate, maintain, and improve the platform and its AI features.</p>
            <p>To personalize your experience and remember your preferences.</p>
            <p>To communicate with you about your account, updates, and support requests.</p>
            <p>To protect the security and integrity of the service.</p>
        </LegalSection>
        <LegalSection title="4. Cookies & Analytics">
            <p>
                We use essential cookies for core functionality and analytics cookies to understand how the service is
                used. You can disable non-essential cookies in your browser settings, though some features may not work
                as expected.
            </p>
        </LegalSection>
        <LegalSection title="5. Sharing of Information">
            <p>We do not sell your personal information.</p>
            <p>
                We share data only with trusted service providers (such as hosting and analytics partners) under
                contractual safeguards, or when required by law.
            </p>
        </LegalSection>
        <LegalSection title="6. Data Retention & Security">
            <p>
                We retain information for as long as needed to provide the service and apply industry-standard
                technical and organizational safeguards. No method of transmission or storage is completely secure, but
                we work to protect your data.
            </p>
        </LegalSection>
        <LegalSection title="7. Your Rights">
            <p>
                You may request access to, correction of, or deletion of your personal information at any time by
                contacting us. We will respond within a reasonable timeframe.
            </p>
        </LegalSection>
        <LegalSection title="8. Changes to This Policy">
            <p>
                We may update this policy from time to time. Material changes will be posted on this page with an
                updated date.
            </p>
        </LegalSection>
        <LegalSection title="9. Contact">
            <p>
                Questions about this policy? Reach us at{" "}
                <span className="text-white">legal@redeemdeals.com</span>.
            </p>
        </LegalSection>
    </LegalPage>
);
